<template>
  <div
  :class="classNames">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InViewportContainer',

  props: {
    handler: {
      type: Function,
      required: true
    },
    classNames: {
      type: String,
      required: false
    },
    containerId: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      containerEl: null,
      containerMonitor: null,
      elementWatcher: null,
      isVisible: false
    }
  },

  watch: {
    isVisible (visible) {
      if (visible) {
        this.handler()
      }
    }
  },

  mounted () {
    this._setContainer()
    this._createWatcher()
    this._bindEvents()
  },

  methods: {
    _setContainer () {
      let el
      if (this.containerId) {
        el = document.getElementById(this.containerId)
      } else {
        el = this.$parent.$el
      }

      this.containerEl = el
    },
    _createWatcher () {
      this.containerMonitor = scrollMonitor.createContainer(this.containerEl)
      this.elementWatcher = this.containerMonitor.create(this.$el)
    },
    _bindEvents () {
      this.elementWatcher.on('enterViewport', (state) => {
        this.isVisible = true
      })

      this.elementWatcher.on('exitViewport', (state) => {
        this.isVisible = false
      })
    }
  }
}
</script>
